import type { ObjectGraph } from '@jet/environment/dependencies';
import { ClassicalAPIURL } from './ClassicalAPIURL';
import type { ClassicalAPIResponse } from './types';
import { requestClassicalAPIResource } from '../utilities/requestClassicalAPIResource';
import { Bag } from '../dependencies/bag';

export async function requestViewPage(
    view: string,
    objectGraph: ObjectGraph,
    tab?: string,
    allowEmptySections?: boolean,
): Promise<ClassicalAPIResponse> {
    const countryCode = Bag.countryCode(objectGraph);
    const url = new ClassicalAPIURL(
        `/query/view/${countryCode}/${view}`,
        objectGraph,
    );

    if (tab) {
        url.queryString.addParameters({
            tab,
        });
    }

    return requestClassicalAPIResource(
        { url: url.string },
        objectGraph,
        allowEmptySections,
    );
}

// See all data will have a query property that already contains a query URL
// with the necessary paths and query parameters.  They are not directly-loadable
// pages, so there won't be a view type immediately available/known, unlike a
// known view page type (album, playlist, etc.)
//
// ex: "/query/view/us/mixed-section/The%20Piano"
// ex: "/query/view/us/section/Periods%20and%20Genres/playlists?q="
export async function requestViewPageWithQuery(
    query: string,
    objectGraph: ObjectGraph,
    optionalHeaders: Record<string, string> = {},
): Promise<ClassicalAPIResponse> {
    const url = new ClassicalAPIURL(`${query}`, objectGraph);

    return requestClassicalAPIResource(
        { url: url.string, headers: optionalHeaders },
        objectGraph,
    );
}
